import styled from 'styled-components'

export const Root = styled.div`
  position: relative;
  z-index: 100;
  width: 100%;
  background: #fff;
  color: #3d2f00;
  padding: 12px 16px;

  /* Drop below the fixed menu, then cancel the Carousel's menu-height
     padding-top (margin-bottom) so page content follows right after. */
  margin-top: ${p => p.theme.blocks.menuHeight};
  margin-bottom: -${p => p.theme.blocks.menuHeight};

  ${p => p.theme.mq.upMd} {
    padding: 16px;
    margin-top: ${p => p.theme.blocks.menuHeightMd};
    margin-bottom: -${p => p.theme.blocks.menuHeightMd};
  }
`

export const Inner = styled.div`
  max-width: 720px;
  margin: 0 auto;
  padding: 14px 18px;
  background: #fff8e1;
  border: 1px solid #f5d547;
  border-radius: 12px;
  font-family: ${p => p.theme.typography.baseFont};
  font-size: 13px;
  line-height: 19px;

  ${p => p.theme.mq.upMd} {
    padding: 16px 20px;
    font-size: 14px;
    line-height: 21px;
  }
`

export const Title = styled.p`
  margin: 0 0 12px;
  font-weight: 700;
`

export const Text = styled.p`
  margin: 0 0 10px;

  &:last-child {
    margin-bottom: 0;
  }
`
